/**
 * User role and level constants for the application
 */

export const USER_ROLES = [
  {
    id: 'dentist',
    label: 'I am a Dentist',
    userlevel: 4
  },
  {
    id: 'hygienist',
    label: 'I am a Hygienist',
    userlevel: 3
  },
  {
    id: 'dental_professional',
    label: 'I am a Dental Professional',
    userlevel: 35
  },
  {
    id: 'developer_software_company',
    label: 'Developer / Software Company',
    userlevel: 36
  }
];

/**
 * Get userlevel for a given role id
 * @param {string} roleId - The role id
 * @returns {number} The userlevel
 */
export const getUserlevelByRole = (roleId) => {
  const role = USER_ROLES.find(r => r.id === roleId);
  return role ? role.userlevel : 4; // Default to dentist level
};

/**
 * Get role id for a given userlevel
 * @param {number} userlevel - The userlevel
 * @returns {string} The role id
 */
export const getRoleByUserlevel = (userlevel) => {
  const role = USER_ROLES.find(r => r.userlevel === userlevel);
  return role ? role.id : 'dentist'; // Default to dentist
};
